export const Logo = ({ light = false, className = "" }) => (
  <span className={`flex items-center gap-3 ${className}`}>
    <img
      src={light ? "/brand/mark-light.png" : "/brand/mark.png"}
      alt=""
      aria-hidden="true"
      width="34"
      height="42"
      className="h-10 w-auto"
    />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-[15px] font-bold tracking-[0.12em] ${light ? "text-white" : "text-[#3A414B]"}`}>
        ASSE <span className={light ? "text-[#C9A66B]" : "text-[#8A6C3E]"}>DECOR</span>
      </span>
      <span className={`mt-1 font-display text-[9px] font-medium tracking-[0.42em] ${light ? "text-white/75" : "text-[#3A414B]/80"}`}>
        INTERIORISMO
      </span>
    </span>
  </span>
);
